<template>
    <div class="main-container">
        <img class="logo" src="../../assets/Drifter/icon.png" alt="Logo"/>
        <span class="desc">Drifter AR does not collect any private information. No servers, works in Airplane Mode.<br>
        Enjoy!</span>
    </div>
</template>

<style scoped>
    .main-container{
        display:flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        height:100%;
        width:100%;
    }

    .logo{
        max-width:320px;
        width:80%;
        border-radius: 50px;
    }

    .desc{
        font-size:14pt;
    }
</style>

<script>

    export default {
        name: "DrifterPolicy"
    }

</script>